import { validationRules } from '../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConnections,
  defaultConstruction,
  defaultCosts,
  defaultDescription,
  defaultObjectNumbers,
  defaultOfficeBasicInfo,
  defaultOfficeRentOtherFacilities,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'

export const agentOfficeRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: defaultOfficeBasicInfo,
  costs: { ...defaultCosts, courtageNote: validationRules.courtageNote, courtage: validationRules.courtage },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  otherFacilities: defaultOfficeRentOtherFacilities,
  connections: defaultConnections,
  objectNumbers: defaultObjectNumbers,
  construction: defaultConstruction,
  apiSearchData: defaultApiSearchData,
}
